import { Injectable } from '@angular/core';
import { Configuration } from './configuration.data';
import { UserImageData } from 'src/app/data/user/user-image.data';
import { UserExcelData } from './user/user-excel.data';

@Injectable()
export class UserData {

  private _folders: Array<string> = [];
  private _images: Array<UserImageData> = [];
  private _excels: Array<UserExcelData> = [];

  public id:number = 0;

  /**
	 * Constructor
	 */
  constructor() {

  }




  /**
	 * CSV
	 */
  public get excels(): Array<UserExcelData> {
    return this._excels;
  }

  /**
	 * Images
	 */
  public get images(): Array<UserImageData> {
    return this._images;
  }

  /**
	 * Folders
	 */
  public get folders(): Array<string> {
    return this._folders;
  }

}
